var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pause"},[_c('button',{attrs:{"fill":""},on:{"click":_vm.chooseResponse}},[_vm._v(_vm._s(_vm.message.options.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }